module.exports = __webpack_public_path__ + "04a1f800fb294aea81f4a3583623e10b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/hochformat/04.jpg
// module id = 141
// module chunks = 0